<template>
  <div class="table-page">
    <span>共有{{total}}条，每页显示：{{display}}条 </span>
    <ul>
      <li :class="{'disabled': current == 1}" @click="setCurrent(1)">首页</li>
      <li :class="{'disabled': current == 1}" @click="setCurrent(current - 1)">上一页</li>
      <li v-for="p in grouplist" :key="p.id" :class="{'on': current == p.val}" @click="setCurrent(p.val)">{{ p.text }}</li>
      <li :class="{'disabled': current == page}" @click="setCurrent(current + 1)">下一页</li>
      <li :class="{'disabled': current == page}" @click="setCurrent(page)">末页</li>
    </ul>
  </div>
</template>
<script>
  export default {
    name: "page",
    props: {
      total: { // 数据总条数
        type: Number,
        default: 0
      },
      display: { // 每页显示条数
        type: Number,
        default: 10
      },
      currentspage: { // 当前页码
        type: Number,
        default: 1
      },
      pagegroup: { // 分页条数
        type: Number,
        default: 5,
        coerce: function(v) {
          v = v > 0 ? v : 5;
          return v % 2 === 1 ? v : v + 1;
        }
      }
    },
    data: function() {
      return {
        gopage: this.currentspage,
        current: this.currentspage
      }
    },
    computed: {
      page: function() { // 总页数
        return Math.ceil(this.total / this.display);
      },
      grouplist: function() { // 获取分页页码
        var len = this.page,
          temp = [],
          list = [],
          count = Math.floor(this.pagegroup / 2),
          center = this.current;
        if (len <= this.pagegroup) {
          while (len--) {
            temp.push({
              text: this.page - len,
              val: this.page - len
            });
          };
          return temp;
        }
        while (len--) {
          temp.push(this.page - len);
        };
        var idx = temp.indexOf(center);
        (idx < count) && (center = center + count - idx);
        (this.current > this.page - count) && (center = this.page - count);
        temp = temp.splice(center - count - 1, this.pagegroup);
        do {
          var t = temp.shift();
          list.push({
            text: t,
            val: t
          });
        } while (temp.length);
        if (this.page > this.pagegroup) {
          (this.current > count + 1) && list.unshift({
            text: '...',
            val: list[0].val - 1
          });
          (this.current < this.page - count) && list.push({
            text: '...',
            val: list[list.length - 1].val + 1
          });
        }
        return list;
      }
    },
    methods: {
      setCurrent: function(idx) {
        if (this.current != idx && idx > 0 && idx < this.page + 1) {
          this.current = idx;
          this.$emit('pageNo', this.current);
          this.$emit('parentMethod', {
            pageNo: idx,
            pageSize: this.display
          });
        }
      }
    }
  };
</script>
<style>
  .table-page {
    width: 100%;
    display: flex;
    height: 30px;
  }

  .table-page span {
    height: 30px;
    line-height: 30px;
  }

  .table-page ul {
    margin: 0;
    padding: 0;
    margin-left: 20px;
    list-style-type: none;
    display: flex;
  }

  .table-page ul li {
    border: 1px #ddd solid;
    border-left: 0;
    height: 28px;
    line-height: 28px;
    padding:0 10px;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Chrome/Safari/Opera */
    -khtml-user-select: none; /* Konqueror */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
    not supported by any browser */
  }

  .table-page ul li.on {
    color: #fff;
    background: #0070c9;
  }

  .table-page ul li:first-child {
    border: 1px #ddd solid;
    width: auto;
    line-height: 26px;
    padding: 0 10px;
  }

  .table-page ul li:last-child {
    width: auto;
    line-height: 26px;
    padding: 0 10px;
  }

  .table-page ul li:nth-child(2) {
    width: auto;
    line-height: 26px;
    padding: 0 10px;
  }

  .table-page ul li:nth-last-child(2) {
    width: auto;
    line-height: 26px;
    padding: 0 10px;
  }

  .table-page button {
    background: #f5f5f5;
    border: 1px #ddd solid;
    height: 30px;
    width: 30px;
    margin-left: 20px;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }

  .table-page input {
    border: 1px #ddd solid;
    width: 45px;
    margin-left: 20px;
    height: 30px;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/page.vue